// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { cotaService } from "../services/cotaService";
import { Cota } from "../interfaces/Cota";

export const useBuscarCota = (cotaId: number | undefined, fetch: boolean) => {
  const [isLoading, setIsLoading] = useState(true);
  const [cota, setCota] = useState<Cota | undefined>(undefined);

  useEffect(() => {
    const fetchCotaUsuario = async () => {
      if (cotaId && fetch) {
        setIsLoading(true);
        try {
          const data = await cotaService(cotaId);
          if (data) {
            setCota(data);
          } else {
            console.error("Dados não encontrados para o usuário");
          }
        } catch (error) {
          console.error("Erro ao buscar cota:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchCotaUsuario();
  }, [cotaId, fetch]); // Dependência de cotaId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, cota };
};
